import { useEffect } from "react";

export const useFrameBusting = () => {
  useEffect(() => {
    if (window.self !== window.top) {
      window.top.location.href = window.self.location.href;
    }
  }, []);
};